import { type FC, useCallback, type MouseEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import dibsCss from 'dibs-css';
import { Link } from 'dibs-elements/exports/Link';
import { trackEvent } from 'dibs-tracking';
import { handleLocaleUrl } from 'dibs-intl/exports/urls';
import classnames from 'classnames';
import { Button } from 'dibs-elements/exports/Button';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

export const PdpSharedBuyerIncentivesLink: FC<{
    isPDPDesktopAggregationVariant?: boolean;
    isDibsPromiseVariant?: boolean;
}> = ({ isPDPDesktopAggregationVariant, isDibsPromiseVariant }) => {
    const intl = useIntl();
    const { isMobile } = useServerVarsContext();

    const incentivesLinkClick: MouseEventHandler = useCallback(event => {
        trackEvent(
            {
                category: 'product',
                action: 'Learn More Click',
                label: 'pdp description | 1stDibs Promise',
            },
            event
        );
    }, []);

    const message = (
        <FormattedMessage id="PdpSharedBuyerIncentivesLink.learnMore" defaultMessage="Learn More" />
    );

    return isDibsPromiseVariant ? (
        <div
            className={classnames(dibsCss.flex, dibsCss.justifyCenter, {
                [dibsCss.mtMedium]: isMobile,
                [dibsCss.mtLarge]: !isMobile,
                [dibsCss.pbXsmall]: isMobile,
            })}
        >
            <Button
                href={handleLocaleUrl('/about/promise/', intl.locale)}
                target="_blank"
                type="secondary"
                size="medium"
                onClick={incentivesLinkClick}
                className={classnames(dibsCss.w300px)}
                fullWidth={!!isMobile}
            >
                {message}
            </Button>
        </div>
    ) : (
        <Link
            href={handleLocaleUrl('/about/promise/', intl.locale)}
            target="_blank"
            onClick={incentivesLinkClick}
            className={classnames({
                [dibsCss.sassyFontBodyMedium]: !isPDPDesktopAggregationVariant,
                [dibsCss.sassyFontBodySmall]: isPDPDesktopAggregationVariant,
            })}
        >
            {message}
        </Link>
    );
};
